function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { checkIsManifestLinearType } from '../../../utils/playback-type';
import { TimelineItemType } from './timeline.enums';
export { TimelineItemType } from './timeline.enums';
/**
 * @public
 */ export var Timeline = /*#__PURE__*/ function() {
    "use strict";
    function Timeline(mainAsset, options) {
        _class_call_check(this, Timeline);
        _define_property(this, "options", void 0);
        _define_property(this, "id", void 0);
        _define_property(this, "timelineItems", void 0);
        this.options = options;
        this.id = "TLine-".concat("0000".concat(++Timeline.idCount).slice(-4));
        this.timelineItems = [
            {
                startTime: 'start',
                endTime: 'end',
                type: TimelineItemType.MainContent,
                asset: mainAsset,
                id: this.generateTimelineItemId()
            }
        ];
    }
    _create_class(Timeline, [
        {
            key: "insertAdverts",
            value: function insertAdverts(advertAssets, position, adBreakDuration) {
                var _this = this;
                var adverts = advertAssets.map(function(advertAsset) {
                    return {
                        startTime: 'start',
                        endTime: 'end',
                        type: TimelineItemType.Advert,
                        asset: advertAsset,
                        id: _this.generateTimelineItemId()
                    };
                });
                if (position === 'start' || position === 0) {
                    this.insertPreAdverts(adverts);
                } else if (position === 'end') {
                    this.insertPostAdverts(adverts);
                } else {
                    this.insertMidAdverts(adverts, position, adBreakDuration);
                }
                return adverts;
            }
        },
        {
            key: "removeAdverts",
            value: function removeAdverts(advertAssets) {
                // remove the specified adverts from the timeline
                var removed = [];
                var newTimelineItems = this.timelineItems.filter(function(timelineItem) {
                    var isAdvert = timelineItem.type === TimelineItemType.Advert;
                    var isRemoved = isAdvert && advertAssets.find(function(advertAsset) {
                        return advertAsset.id === timelineItem.asset.id;
                    });
                    if (isRemoved) {
                        removed.push(timelineItem);
                    }
                    return !isRemoved;
                });
                // stitch together any consecutive pieces of main content
                this.timelineItems = newTimelineItems.reduce(function(reducedItems, currentItem, index) {
                    if (reducedItems.length === 0) {
                        return [
                            currentItem
                        ];
                    }
                    var previousItem = reducedItems[reducedItems.length - 1];
                    if (previousItem.type === TimelineItemType.MainContent && currentItem.type === TimelineItemType.MainContent && previousItem.endTime === currentItem.startTime) {
                        previousItem.endTime = currentItem.endTime;
                        return reducedItems;
                    }
                    reducedItems.push(currentItem);
                    return reducedItems;
                }, []);
                return removed;
            }
        },
        {
            key: "getMainContentItemForPosition",
            value: function getMainContentItemForPosition(targetPosition) {
                return this.timelineItems.find(function(item) {
                    return item.type === TimelineItemType.MainContent && (item.startTime === 'start' || item.startTime <= targetPosition) && (item.endTime === 'end' || item.endTime >= targetPosition);
                });
            }
        },
        {
            key: "getFirstTimelineItem",
            value: function getFirstTimelineItem() {
                return this.timelineItems[0];
            }
        },
        {
            key: "getNextTimelineItem",
            value: function getNextTimelineItem(currentTimelineItem) {
                var currentIndex = this.timelineItems.findIndex(function(timelineItem) {
                    return timelineItem === currentTimelineItem;
                });
                if (this.timelineItems.length > currentIndex + 1) {
                    return this.timelineItems[currentIndex + 1];
                } else {
                    return null;
                }
            }
        },
        {
            key: "toString",
            value: function toString() {
                var output = "Details of ".concat(this.id, ":\n");
                this.timelineItems.forEach(function(timelineItem, index) {
                    output += "".concat(index + 1, ". ").concat(timelineItem.id, " ").concat(timelineItem.asset.id, " (").concat(timelineItem.type, "): ");
                    output += "".concat(timelineItem.startTime, " to ").concat(timelineItem.endTime, "\n");
                });
                return output;
            }
        },
        {
            key: "insertMidAdverts",
            value: function insertMidAdverts(adverts, position, adBreakDuration) {
                var _this = this;
                var newTimeline = new Array();
                var offsettedResumePosition = checkIsManifestLinearType(this.options.playbackType) ? adBreakDuration : 0;
                this.timelineItems.forEach(function(timelineItem) {
                    if (_this.isWithinBounds(timelineItem.startTime, timelineItem.endTime, position) && timelineItem.type === TimelineItemType.MainContent) {
                        var _newTimeline;
                        var _this_splitTimelineItem = _sliced_to_array(_this.splitTimelineItem(timelineItem, position), 2), timelineItemFirstHalf = _this_splitTimelineItem[0], timelineItemSecondHalf = _this_splitTimelineItem[1];
                        timelineItemSecondHalf.startTime += offsettedResumePosition;
                        (_newTimeline = newTimeline).push.apply(_newTimeline, [
                            timelineItemFirstHalf
                        ].concat(_to_consumable_array(adverts), [
                            timelineItemSecondHalf
                        ]));
                    } else {
                        newTimeline.push(timelineItem);
                    }
                });
                this.timelineItems = newTimeline;
            }
        },
        {
            key: "insertPreAdverts",
            value: function insertPreAdverts(adverts) {
                this.timelineItems = _to_consumable_array(adverts).concat(_to_consumable_array(this.timelineItems));
            }
        },
        {
            key: "insertPostAdverts",
            value: function insertPostAdverts(adverts) {
                this.timelineItems = _to_consumable_array(this.timelineItems).concat(_to_consumable_array(adverts));
            }
        },
        {
            key: "splitTimelineItem",
            value: function splitTimelineItem(timelineItem, splitPosition) {
                if (!this.isWithinBounds(timelineItem.startTime, timelineItem.endTime, splitPosition)) {
                    throw new Error('ERROR.TIMELINE.INVALID_SPLIT');
                }
                if (splitPosition === 'start' || splitPosition === 'end') {
                    throw new Error('ERROR.TIMELINE.INVALID_SPLIT');
                }
                var endTime = timelineItem.endTime;
                timelineItem.endTime = splitPosition;
                return [
                    timelineItem,
                    _object_spread_props(_object_spread({}, timelineItem), {
                        startTime: splitPosition,
                        endTime: endTime,
                        id: this.generateTimelineItemId()
                    })
                ];
            }
        },
        {
            key: "isWithinBounds",
            value: function isWithinBounds(start, end, position) {
                if (start === 'start' && end === 'end') {
                    return true;
                } else if (start === position || end === position) {
                    return true;
                } else if (start === 'start' && position <= end) {
                    return true;
                } else if (end === 'end' && position >= start) {
                    return true;
                } else {
                    return start <= position && position <= end;
                }
            }
        },
        {
            key: "generateTimelineItemId",
            value: function generateTimelineItemId() {
                return "TLineItem-".concat("0000".concat(++Timeline.timelineItemIdCount).slice(-4));
            }
        }
    ]);
    return Timeline;
}();
_define_property(Timeline, "timelineItemIdCount", 0);
_define_property(Timeline, "idCount", 0);

//# sourceMappingURL=timeline.js.map